import React, { useState } from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import LinkButton from './LinkButton';
import OnboardingGreeting from './OnboardingGreeting';
import { DisplayHeader, Header2 } from './Typography';
import {
  mediaBreakpointUpSM,
  mediaBreakpointUpMD,
  mainFontFamily,
  ssColorWhite,
  ssColorCyan,
  mediaBreakpointUpLG,
} from '../constants/style-constants';
import onboardPropTypes from '../proptypes/onboard-splash';
import { vunit } from '../lib/style-helpers';
import LinkTicketModule from './LinkTicketModule';
import Modal from './Modal';

const returningVisitorTitleCss = css`
  color: ${ssColorWhite};
  font-size: 0.8rem;
  font-family: ${mainFontFamily};
  margin-bottom: ${vunit(2)};
  text-align: center;
`;

const ReturningVisitorCard = ({ title, buttonLabel, buttonAction }) => (
  <>
    <h3 css={returningVisitorTitleCss}>{title}</h3>
    <button onClick={buttonAction} type="button" className="btn btn-secondary btn-block">{buttonLabel}</button>
  </>
);
ReturningVisitorCard.propTypes = {
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
};

const containerCss = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${vunit(5)} 0;

  ${mediaBreakpointUpMD} {
    min-height: 500px;
    height: 55vh;
  }
`;

const widthContainerCss = css`
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const headerCss = css`
  color: ${ssColorCyan};
  text-align: center;

  ${mediaBreakpointUpSM} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const bodyTitleCss = css`
  color: ${ssColorCyan};
  display: block;
  font-size: 2.4rem;
  margin-bottom: ${vunit(5)};
  text-align: center;

  ${mediaBreakpointUpSM} {
    font-size: 3.6rem;
    margin-bottom: ${vunit(6)};
  }

  ${mediaBreakpointUpLG} {
    font-size: 4rem;
  }
`;

const introCss = css`
  color: ${ssColorCyan};
  font-size: 1.2rem;
  text-align: center;
  text-transform: none;

  ${mediaBreakpointUpSM} {
    font-size: 1.6rem;
  }

  ${mediaBreakpointUpLG} {
    font-size: 1.9rem;
  }
`;

const bodyContentCss = css`
  margin-bottom: ${vunit(4)};
  margin-top: ${vunit(4)};
`;

const OnboardingSplash = ({
  phrases,
  fullName,
  gamesPath,
  linkTickets,
  intro,
}) => {
  const [modalVisible, showModal] = useState(false);

  return (
    <div css={containerCss}>
      <header css={headerCss}>
        <OnboardingGreeting
          fullName={fullName}
          salutation={phrases.salutation}
          noFullNameFallback={phrases.noFullNameGreeting}
        />
      </header>
      <div css={bodyContentCss}>
        {intro && <Header2 css={introCss}>{intro}</Header2>}
        <DisplayHeader css={bodyTitleCss}>{phrases.title}</DisplayHeader>
        <div css={widthContainerCss}>
          <LinkButton className="btn-primary btn-block" title={phrases.startButtonLabel} url={gamesPath} />
        </div>
      </div>
      <aside css={widthContainerCss}>
        <Modal show={modalVisible} onClose={() => showModal(false)}>
          <LinkTicketModule {...linkTickets} />
        </Modal>
        <ReturningVisitorCard
          title={phrases.returnUser.prompt}
          buttonLabel={phrases.returnUser.profileButtonLabel}
          buttonAction={() => showModal(true)}
        />
      </aside>
    </div>
  );
};

OnboardingSplash.defaultProps = {
  fullName: null,
};

OnboardingSplash.propTypes = onboardPropTypes;

export default OnboardingSplash;
